export const invoiceList = {
  head: {
    title: "الفوترة",
    subtitle: "الفواتير الصادرة لضيوفك",
  },
  stats: {
    filterAria: "تصفية الفواتير حسب الحالة",
    total: "الإجمالي",
    draft: "المسودات",
    sent: "الصادرة",
    processing: "قيد المعالجة",
    error: "بها أخطاء",
    pending: "قيد الانتظار",
    voided: "الملغاة",
  },
  toolbar: {
    searchLabel: "البحث عن الفواتير",
    searchPlaceholder: "رقم الفاتورة، العميل، البريد الإلكتروني، الرقم الضريبي أو الحجز…",
    clearSearch: "مسح البحث",
    propertyLabel: "مكان الإقامة",
    allProperties: "كل أماكن الإقامة",
    typeToSearchProperties: "اكتب للبحث عن أماكن الإقامة.",
    noProperties: "لم نعثر على أماكن إقامة.",
    statusLabel: "الحالة",
    emisorLabel: "الجهة المُصدِرة",
    allEmisores: "كل الجهات المُصدِرة",
    servicesTitle: "كتالوج الرسوم والخدمات القابلة لإعادة الاستخدام",
    services: "الرسوم والخدمات",
    createInvoice: "إنشاء فاتورة",
  },
  exportZip: {
    button: "ZIP",
    title: "ملف لكل فاتورة، كل منها بتاريخها ورمز حجزها، وجميعها داخل ملف ZIP واحد",
    generating: "جارٍ الإنشاء…",
    zipping: "جارٍ الضغط…",
    noPdfInPeriod: "لا توجد في هذه الفترة فواتير صادرة بملف PDF.",
    noPdfInPage: "لا توجد في هذه الصفحة فواتير صادرة بملف PDF.",
    tooMany: "يحتوي التحديد على {total} فاتورة ويقبل ملف ZIP ‏{limit}. قلّص الفترة أو عوامل التصفية.",
    noneDownloaded: "لم يتم تنزيل أي فاتورة من Invopop. حاول مرة أخرى بعد بضع دقائق.",
    failed: "لم يتم تنزيل {n} فاتورة من Invopop: {codes}.",
    withoutPdf: "{n} فاتورة ليس لها بعد ملف PDF في Invopop ولن تكون في ملف ZIP: {codes}.",
    restIncluded: "أما الباقي فهو داخل ملف ZIP.",
    error: "لم يتم إنشاء ملف ZIP للفواتير.",
  },
  linkedClient: {
    prefix: "الفواتير المرتبطة بـ",
    fallbackName: "هذا العميل الضريبي",
    clear: "إزالة تصفية العميل",
  },
  table: {
    numberHeader: "رقم الفاتورة",
    customerHeader: "العميل",
    propertyHeader: "مكان الإقامة",
    totalHeader: "الإجمالي",
    statusHeader: "الحالة",
    dateHeader: "التاريخ",
    actionsHeader: "الإجراءات",
    draftReferenceTitle: "مرجع المسودة. يُخصَّص الرقم الضريبي عند الإصدار.",
    openReserva: "فتح الحجز",
    viewCreditNote: "عرض إشعار الدائن {code}",
    creditNote: "فاتورة تصحيحية",
    viewError: "عرض الخطأ",
    voids: "يلغي",
    correctionOf: "تصحيح لـ",
    correctedBy: "مُصحَّحة بواسطة:",
  },
  sortFields: {
    number: "رقم الفاتورة",
    customer: "العميل",
    property: "مكان الإقامة",
    total: "الإجمالي",
    status: "الحالة",
    date: "التاريخ",
  },
  sort: {
    sortBy: "الترتيب حسب {label}",
    sortedBy: "مُرتَّبة حسب {label}، {direction}. تغيير الترتيب",
    asc: "تصاعدي",
    desc: "تنازلي",
  },
  actions: {
    openPdf: "فتح الفاتورة بصيغة PDF",
    editDraftTitle: "تعديل بيانات العميل والبنود",
    edit: "تعديل",
    previewTitle: "فتح معاينة بدون صلاحية ضريبية",
    preview: "معاينة",
    sendQuote: "عرض سعر",
    sendQuoteTitle: "إرسال عرض السعر إلى العميل بالبريد",
    emitTitle: "مراجعة الفاتورة وإصدارها",
    emit: "إصدار",
    syncTitle: "تحديث حالة الفاتورة",
    sync: "تحديث",
    retryTitle: "إعادة المحاولة ببيانات فوترة محدَّثة",
    retry: "إعادة المحاولة",
    moreOptions: "خيارات أخرى",
    moreOptionsAria: "خيارات الفاتورة الأخرى",
    editCustomer: "تعديل بيانات العميل",
    deleteReset: "حذف وإعادة تعيين الطلب",
    voidReissue: "إلغاء وإعادة إصدار",
  },
  empty: {
    searchTitle: "لم نعثر على فواتير",
    searchText: "لا توجد نتائج تطابق البحث والتصفية الحاليين.",
    clearFilters: "مسح عوامل التصفية",
    title: "لا توجد فواتير بعد",
    text: "أنشئ مسودة وأصدرها عندما تكون البيانات الضريبية والرسوم جاهزة.",
    createFirst: "إنشاء أول فاتورة",
  },
  errorModal: {
    title: "خطأ في الفاتورة",
    hintBefore: "إذا كان الخطأ في بيانات الفوترة الخاصة بك (الرقم الضريبي، السلسلة…)، فصحِّحها في",
    hintSettingsPath: "الإعدادات ← الفوترة",
    hintBetween: "ثم استخدم",
    hintRetryWord: "إعادة المحاولة",
    hintGuest: "إذا كان الخطأ في بيانات الضيف، فاستخدم",
    hintEditWord: "تعديل بيانات العميل",
    close: "إغلاق",
    retryNow: "إعادة المحاولة الآن",
  },
  editCustomer: {
    title: "تعديل بيانات العميل",
    subtitle: "صحِّح البيانات وأعد محاولة الفاتورة",
    name: "الاسم / الاسم القانوني *",
    taxId: "الرقم الضريبي / رقم ضريبة القيمة المضافة",
    country: "الدولة (رمز من حرفين) *",
    email: "البريد الإلكتروني *",
    address: "العنوان",
    city: "المدينة",
    zip: "الرمز البريدي",
    hint: "عند الحفظ ستُعاد محاولة إرسال الفاتورة تلقائيًا.",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ وإعادة المحاولة",
  },
  deleteConfirm: {
    title: "حذف الفاتورة",
    body1: "ستُحذف محاولة الفاتورة هذه، و",
    bodyStrong: "ستُعاد تهيئة طلب الضيف",
    body2: "، مما يتيح له إدخال بياناته وطلب الفاتورة من جديد.",
    irreversible: "لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    deleting: "جارٍ الحذف…",
    confirm: "نعم، احذف",
  },
  create: {
    titleEdit: "تعديل المسودة",
    titleCreate: "إنشاء فاتورة",
    subtitleEdit: "حدِّث العميل والسياق والبنود. لا يتم الإصدار.",
    subtitleCreate: "مسودة — بدون رقم حتى الإصدار. لا تتطلب حجزًا.",
    loading: "جارٍ تحميل المسودة…",
    clientLabel: "العميل *",
    clientHelp: "اختر ملف فوترة محفوظًا أو أنشئ ملفًا جديدًا.",
    newClient: "عميل جديد",
    company: "شركة",
    individual: "فرد",
    change: "تغيير",
    clientSearchPlaceholder: "ابحث بالاسم أو البريد الإلكتروني أو المستند…",
    incomplete: "غير مكتمل",
    noClients: "لم نعثر على عملاء.",
    createClient: "إنشاء عميل",
    contextTitle: "سياق الفاتورة",
    optional: "اختياري",
    contextHelp: "اربط هذه الفاتورة للحفاظ على إمكانية تتبعها. يمكنك ترك كلا الحقلين فارغين.",
    propertyLabel: "مكان الإقامة",
    propertyPlaceholder: "ابحث عن مكان إقامة…",
    typeToSearchProperties: "اكتب للبحث عن أماكن الإقامة.",
    noProperties: "لم نعثر على أماكن إقامة.",
    reservationLabel: "الحجز",
    reservationPlaceholder: "ابحث بالرمز أو الضيف أو البريد الإلكتروني…",
    noHolder: "بدون صاحب حجز",
    typeToSearchReservations: "اكتب للبحث عن الحجوزات.",
    noReservations: "لم نعثر على حجوزات.",
    contextNotice: "يحدِّد الحجز مكان الإقامة ويضيف الإقامة إذا لم تُفوتر بعد.",
    chargesTitle: "الرسوم والخدمات",
    chargesHelp: "اختر بنودًا محفوظة في الكتالوج الخاص بك.",
    addCharge: "إضافة رسم أو خدمة",
    colConcept: "البند",
    colQty: "الكمية",
    colUnitPrice: "سعر الوحدة",
    colTotal: "الإجمالي",
    docTitle: "هكذا ستبدو الفاتورة",
    docHint: "هذه هي البنود التي سيحملها ملف PDF. الإقامة والخصومات والرسوم التلقائية تأتي من الحجز: في الأعلى تحرّر فقط رسوم الكتالوج الخاص بك.",
    due: "المبلغ المستحق",
    assumed: "لا توجد مدفوعات مسجلة على هذا الحجز. يُعتبر المبلغ محصّلاً بناءً على طريقة الدفع المحددة، وسيظهر كذلك في ملف PDF.",
    linesEmpty: "أضف بندًا واحدًا أو أكثر من الكتالوج الخاص بك.",
    total: "الإجمالي",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveChanges: "حفظ التغييرات",
    saveDraft: "حفظ المسودة",
  },
  contextSummary: {
    property: "تم اختيار مكان الإقامة",
    empty: "إضافة مكان إقامة أو حجز",
  },
  emit: {
    title: "إصدار الفاتورة",
    subtitle: "سيخصِّص هذا الإجراء الرقم الضريبي النهائي.",
    client: "العميل",
    property: "مكان الإقامة",
    total: "الإجمالي",
    warning: "بعد الإصدار لن تتمكن من تعديلها مباشرة؛ وأي تصحيح سيتطلب مستندًا تصحيحيًا.",
    cancel: "إلغاء",
    emitting: "جارٍ الإصدار…",
    confirm: "إصدار الفاتورة",
  },
  editDraft: {
    title: "تعديل المسودة",
    subtitle: "عدِّل بيانات العميل والبنود. لا يتم الإصدار.",
    loading: "جارٍ تحميل المسودة…",
    individual: "فرد",
    individualSub: "شخص طبيعي",
    company: "شركة",
    companySub: "شخص اعتباري",
    legalName: "الاسم القانوني *",
    fullName: "الاسم الكامل *",
    companyNamePlaceholder: "اسم الشركة",
    individualNamePlaceholder: "الاسم واللقب",
    country: "الدولة *",
    docCompany: "الرقم الضريبي للشركة (ضريبة القيمة المضافة)",
    docIndividual: "الهوية / جواز السفر",
    docCompanyPlaceholder: "ضريبة القيمة المضافة / الرقم الضريبي",
    docIndividualPlaceholder: "الهوية الوطنية أو جواز السفر",
    email: "البريد الإلكتروني",
    emailOptional: "(اختياري)",
    lodgingTitle: "مكان الإقامة",
    lodgingName: "مكان الإقامة",
    lodgingNoteBefore: "مأخوذ من الحجز",
    lodgingNoteAfter: ". لتغيير هذا المبلغ، عدِّله في الحجز.",
    chargesTitle: "الرسوم والخدمات",
    chargesHelp: "أضف بنودًا محفوظة دون تغيير مكان الإقامة.",
    addCharge: "إضافة رسم أو خدمة",
    colConcept: "البند",
    colQty: "الكمية",
    colUnitPrice: "سعر الوحدة",
    colTotal: "الإجمالي",
    linesEmpty: "لا توجد بنود إضافية.",
    linesEmptyReserva: "تتضمن الفاتورة مكان الإقامة فقط.",
    total: "الإجمالي",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveChanges: "حفظ التغييرات",
  },
  void: {
    doneTitle: "تم إلغاء الفاتورة",
    doneSubtitle: "تم إصدار الفاتورة التصحيحية بنجاح",
    whatHappened: "ماذا حدث؟",
    doneCreditNote: "تم إصدار الفاتورة التصحيحية",
    doneListed: "تبقى الفاتورة في القائمة موسومة بأنها ملغاة",
    doneCharges: "تم تحرير الرسوم الإضافية",
    doneGuest: "يمكن للضيف طلب فاتورته من جديد",
    nextStepsLabel: "الخطوات التالية:",
    nextStepsText: "يمكنك إضافة الرسوم أو تصحيحها في الحجز. ثم أعد إرسال رابط الفوترة إلى الضيف.",
    understood: "فهمت",
    title: "إلغاء وإعادة إصدار الفاتورة",
    introBefore: "هذا الإجراء",
    introStrong: "سيُلغي الفاتورة الصادرة",
    introAfter: "بواسطة فاتورة تصحيحية رسمي.",
    willEmit: "سيتم إصدار فاتورة تصحيحية",
    willList: "ستبقى الفاتورة في القائمة موسومة بأنها ملغاة",
    willFree: "سيتم تحرير الرسوم الإضافية",
    willAllowGuest: "سيتمكن الضيف من طلب الفاتورة من جديد",
    reasonLabel: "سبب الإلغاء",
    reasonOther: "سبب آخر…",
    reasonPlaceholder: "اشرح سبب إلغائك لهذه الفاتورة",
    warning: "إشعار الدائن مستند ضريبي رسمي. استخدمه فقط إذا كنت بحاجة فعلية لتصحيح الفاتورة.",
    cancel: "إلغاء",
    emitting: "جارٍ إصدار إشعار الدائن…",
    confirm: "نعم، ألغِ وأعد الإصدار",
  },
  statusFilters: {
    all: "الكل",
    draft: "المسودات",
    sent: "الصادرة",
    processing: "قيد المعالجة",
    error: "بها أخطاء",
    pending: "قيد الانتظار",
    voided: "الملغاة",
  },
  voidReasons: {
    wrongTaxData: "بيانات ضريبية غير صحيحة للعميل",
    wrongAmount: "مبلغ أو رسوم غير صحيحة",
    duplicate: "فاتورة مكررة",
    cancelledReservation: "حجز ملغى",
    reissue: "إلغاء لإعادة الإصدار ببيانات أو رسوم مُصحَّحة",
  },
  statusLabels: {
    draft: "مسودة",
    sent: "صادرة",
    processing: "قيد المعالجة",
    error: "خطأ",
    pending: "قيد الانتظار",
    corrected: "مُصحَّحة",
    voided: "ملغاة",
  },
  client: {
    fallbackName: "عميل",
    fiscalPending: "ملف الفوترة قيد الانتظار",
    fiscalSaved: "تم حفظ ملف الفوترة",
  },
  reservation: {
    noCode: "بدون رمز",
    noDates: "بدون تواريخ",
    noHolder: "بدون صاحب حجز",
    propertyFallback: "مكان الإقامة #{id}",
  },
  emisorFallback: "الجهة المُصدِرة #{id}",
  toasts: {
    selectClientComplete: "اختر عميلًا لديه ملف فوترة مكتمل.",
    selectReservationOrCharge: "اختر حجزًا أو أضف رسمًا أو خدمة واحدة على الأقل.",
    saveDraftError: "تعذَّر حفظ المسودة.",
    createError: "تعذَّر إنشاء الفاتورة.",
    quoteSent: "تم إرسال عرض السعر إلى {email}",
    quoteError: "تعذّر إرسال عرض السعر.",
    previewError: "تعذَّر إنشاء المعاينة.",
    previewName: "معاينة",
    emitRejected: "رفضت المنصة الضريبية الإصدار.",
    emitError: "تعذَّر إصدار الفاتورة. تحقق من البيانات الضريبية وحاول مجددًا.",
    selectClientToContinue: "اختر عميلًا لديه ملف فوترة للمتابعة.",
    loadDraftError: "تعذَّر تحميل بيانات المسودة.",
    nameRequired: "أدخل اسم العميل.",
    countryRequired: "اختر دولة العميل.",
    selectCatalogCharge: "اختر رسمًا أو خدمة واحدة على الأقل من الكتالوج.",
    retryError: "تعذَّرت إعادة المحاولة.",
    saveError: "تعذَّر الحفظ.",
    voidError: "تعذَّر إلغاء الفاتورة.",
    deleteError: "تعذَّر الحذف.",
  },
};
